import GroupedProjectFinancials from "./grouped/grouped-project-financials";
import SingleProjectFinancials from "./single-project/single-project-financials";

const ProjectFinancials = ({ isGroupView, companyData }) => {
  return (
    <div>
      {isGroupView && <GroupedProjectFinancials companyData={companyData} />}
      {!isGroupView && <SingleProjectFinancials companyData={companyData} />}
    </div>
  );
};

export default ProjectFinancials;
